/* ============================================================
   Variant picker — keeps the hidden `id` input in sync with the
   selected radio options. Teeinblue takes over the submit when
   active; this script is the no-Teeinblue fallback.

   Each form must carry a data-zc-product-variants JSON array
   of { id, options: [v1, v2, …] } in the order of product.options.
   ============================================================ */
(function () {
  'use strict';

  const forms = document.querySelectorAll('[data-zc-product-form]');
  if (!forms.length) return;

  forms.forEach((form) => {
    const idInput = form.querySelector('[data-zc-variant-id]');
    const variantsScript = form.querySelector(
      'script[type="application/json"][data-zc-variants]'
    );
    let variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }
    if (!idInput || !variants.length) return;

    const optionFieldsets = Array.from(form.querySelectorAll('.zc-variant-option'));

    const selectedOptions = () =>
      optionFieldsets.map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

    const matchVariant = (selected) =>
      variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === selected.length &&
          v.options.every((opt, i) => opt === selected[i])
      );

    const update = () => {
      const selected = selectedOptions();
      if (selected.some((s) => s === null)) return;
      const match = matchVariant(selected);
      if (!match) {
        idInput.value = '';
        return;
      }
      idInput.value = match.id;
      form.dispatchEvent(
        new CustomEvent('zc:variant:change', {
          detail: { variant: match },
          bubbles: true,
        })
      );
    };

    form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', update);
    });
  });
})();
